import {
  EMAIL_REGEX,
  MAX_NAME_LENGTH,
  MAX_EMAIL_LENGTH,
  MAX_MESSAGE_LENGTH,
  containsDangerousChars,
  emailContainsDangerousChars,
} from '../../src/helpers/sanitizeInput.helper'

export type ValidationResult = { isValid: boolean; error?: string }

export function validateName(name: string): ValidationResult {
  const trimmed = name.trim()

  if (!trimmed) {
    return { isValid: false, error: 'nameRequired' }
  }

  if (trimmed.length > MAX_NAME_LENGTH) {
    return { isValid: false, error: 'nameTooLong' }
  }

  // Defense in depth: check dangerous chars even after sanitizeInput
  const dangerousChars = /[<>&`/%"']/
  if (dangerousChars.test(trimmed)) {
    return { isValid: false, error: 'invalidCharacters' }
  }

  if (/<script|javascript:|data:|vbscript:|on\w+\s*=/i.test(trimmed)) {
    return { isValid: false, error: 'invalidCharacters' }
  }

  // eslint-disable-next-line no-control-regex
  if (/[\x00-\x08\x0B-\x0C\x0E-\x1F\x7F]/.test(trimmed)) {
    return { isValid: false, error: 'invalidCharacters' }
  }

  return { isValid: true }
}

export function validateEmail(email: string): ValidationResult {
  const trimmed = email.trim()

  if (!trimmed) {
    return { isValid: false, error: 'emailRequired' }
  }

  if (trimmed.length > MAX_EMAIL_LENGTH) {
    return { isValid: false, error: 'emailInvalid' }
  }

  if (emailContainsDangerousChars(trimmed)) {
    return { isValid: false, error: 'emailInvalid' }
  }

  if (!EMAIL_REGEX.test(trimmed)) {
    return { isValid: false, error: 'emailInvalid' }
  }

  return { isValid: true }
}

export function validateMessage(message: string): ValidationResult {
  const trimmed = message.trim()

  if (!trimmed) {
    return { isValid: false, error: 'messageRequired' }
  }

  if (trimmed.length > MAX_MESSAGE_LENGTH) {
    return { isValid: false, error: 'messageTooLong' }
  }

  if (containsDangerousChars(trimmed)) {
    return { isValid: false, error: 'invalidCharacters' }
  }

  return { isValid: true }
}
